import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import "./custom-password-field.css";
import PropTypes from "prop-types";

const CustomPasswordField = ({
  value,
  onChange,
  className,
  label = "Password",
  variant = "outlined",
  validationError = false,
}) => {
  const [passwordType, setPasswordType] = useState("password");
  const [showPasswordError, setShowPasswordError] = useState(false);

  const togglePassword = () => {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <MDBox>
      <MDBox className={"password-field " + className}>
        <MDInput
          type={passwordType}
          label={label}
          color="success"
          value={value}
          onChange={onChange}
          variant={variant}
          fullWidth
          className={"inputbox mb-2"}
          required
        />
        <Icon
          style={{ marginRight: "3px" }}
          className={
            validationError
              ? "password-input-icon padding-password-input-icon"
              : "password-input-icon"
          }
          onClick={togglePassword}
        >
          {passwordType == "password" ? "visibility" : "visibility_off"}
        </Icon>
        {validationError && (
          <Icon
            className="password-input-icon red"
            onMouseEnter={() => {
              setShowPasswordError(true);
            }}
            onMouseLeave={() => {
              setShowPasswordError(false);
            }}
          >
            info_outlined
          </Icon>
        )}
      </MDBox>
      {showPasswordError && (
        <MDBox className="col-md-12 error-box-profile" style={{ zIndex: 9999 }}>
          <MDTypography
            color="secondary"
            className="text-red"
            variant="subtitle2"
          >
            Password must be alphanumeric and at least 12 characters long,
            including one uppercase letter and a special character.
          </MDTypography>
        </MDBox>
      )}
    </MDBox>
  );
};
CustomPasswordField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
  validationError: PropTypes.bool,
};
export default CustomPasswordField;
